module.exports = "<div class=\"modal\" ng-click=\"close($event)\" ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\" role=\"dialog\" tabindex=\"-1\"><div class=\"modal-dialog\" ng-class=\"{'modal-dialog_sm': size == 'sm', 'modal-dialog_lg': size == 'lg', 'modal-dialog_md': size == 'md'}\"><div class=\"modal-content\" ng-class=\"modalclass\" ng-transclude=\"\"></div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./~/pug-html-loader/lib!./src/app/common/templates/window.jade
// module id = 293
// module chunks = 0